import { Autocomplete, CircularProgress, Grid, InputLabel, MenuItem, Select, Stack, TextField } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { GenericTableColumn, OrderType } from 'inside-fifa/api/generic-tables/dto';
import { useFormikContext } from 'formik';
import { UpdateConfigDialogFormValues } from '../../dto';

export const DefaultColumnOrder = () =>
{
    const { values, setFieldValue }=
            useFormikContext<UpdateConfigDialogFormValues>();
            
        return (
            <Grid item xs={12} rowGap={3}>
                <Stack spacing={1}>
                    <InputLabel>
                        <FormattedMessage id="inside-fifa.generic-tables.data-source-file" />
                    </InputLabel>
                    {values.config ? (
                        <Autocomplete<GenericTableColumn>
                            options={values.config.columns ?? []}
                            getOptionLabel={(option) => `${option.title} (id: ${option.key})`}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                />
                            )}
                            onChange={(_event, value) => {
                                if (value?.key === undefined || !values.config.columns) {
                                    setFieldValue('config.defaultColumnOrder.key', null);
                                    return;
                                }
                                setFieldValue('config.defaultColumnOrder.key', value?.key);
                            }}
                            value={values.config.defaultColumnOrder.key ? 
                                (values.config.columns ?? []).find((option) => option.key === values.config.defaultColumnOrder.key) : null}
                        />
                    ) : (
                        <CircularProgress color="inherit" size={32} />
                    )}
                    <InputLabel>
                        <FormattedMessage id="inside-fifa.generic-tables.order" />
                    </InputLabel>
                    <Select<OrderType>
                        fullWidth
                        value={values.config.defaultColumnOrder.orderType}
                        onChange={(event) => {
                            const orderType = event.target.value as OrderType;
                            setFieldValue('config.defaultColumnOrder.orderType', orderType);
                        }}
                    >
                        <MenuItem value={OrderType.Asc}>
                            <FormattedMessage id="inside-fifa.generic-tables.order.asc" />
                        </MenuItem>
                        <MenuItem value={OrderType.Desc}>
                            <FormattedMessage id="inside-fifa.generic-tables.order.desc" />
                        </MenuItem>
                    </Select>
                </Stack>
            </Grid>
        );
}